import { render } from "./AttachIso.vue?vue&type=template&id=e8782f5e&scoped=true"
import script from "./AttachIso.vue?vue&type=script&lang=js"
export * from "./AttachIso.vue?vue&type=script&lang=js"

import "./AttachIso.vue?vue&type=style&index=0&id=e8782f5e&lang=scss&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8782f5e"]])

export default __exports__